<template>
    <div class="spinnerLoader abs"><Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner></div>
</template>

<script>
import Spinner from "vue-simple-spinner";

export default {
    components: {
        Spinner
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style scoped lang="scss">
.spinnerLoader {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    top: 0;
    left: 0;
    display: flex;
    border-radius: 3px;
    .loader {
        margin: auto;
    }
}
</style>



// WEBPACK FOOTER //
// Spinner.vue?8d4a6ff6